//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Bar from './Bar'

export default {
  components: {
    Bar,
  },
  props: {
    foregroundColor: {
      type: String,
      default: '#2AB27B',
    },
    backgroundColor: {
      type: String,
      default: '#d7d8d7',
    },
    done: {
      type: Number,
      required: true,
    },
    ongoing: {
      type: Number,
      default: 0,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    tiny: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasOngoingProgressBar() {
      return this.ongoing && this.done < 100
    },
    fillOngoing() {
      if (this.ongoing) {
        return this.vertical
          ? { height: `${this.ongoing}%` }
          : { width: `${this.ongoing}%` }
      }

      return null
    },
  },
}
